import { Subject } from "rxjs";

const $modal = new Subject();

export const ModalService = {
    open: () => $modal.next({show: true}),
    changeInfo: (modalInfo) => $modal.next(modalInfo),
    close: () => $modal.next({show: false}),
    getChanges: () => $modal
};